/* eslint-disable no-nested-ternary */
import React from 'react';
import { styled } from 'linaria/react';
import { getClientBaseAmount, getClientFeeAmount, getClientTotalAmount } from '@features/payment/payment-form';
import { toPriceFormat } from '@shared/lib/money';
import { checkIsServiceNonTopUp, checkIsWithPercentFee, PaymentPayee } from '@entities/tsp';
import { PaymentMethod } from '@entities/payment';
import { Amount } from '@root/api/ump-ewallet';
export const getAmountInfoRows = (showVouchersForm: boolean, amountInfo: Amount | null, payee: PaymentPayee, isPromocodeActivated: boolean, paymentMethod: PaymentMethod) => {
  const isSteam = payee.features?.tsp_url === 'steam';
  const isPubgMobile = payee.features?.tsp_url === 'pubg-mobile';
  const isNonTopUpService = checkIsServiceNonTopUp(showVouchersForm, payee);
  const isTopUpWithPercentFeeService = checkIsWithPercentFee(payee);
  const base = getClientBaseAmount(amountInfo, isPubgMobile, isNonTopUpService, isTopUpWithPercentFeeService, paymentMethod);
  const fee = getClientFeeAmount(amountInfo, isPubgMobile, isNonTopUpService, isTopUpWithPercentFeeService, paymentMethod) as string;
  const total = getClientTotalAmount(amountInfo, isPromocodeActivated, isSteam);
  return [{
    label: !showVouchersForm ? 'Сумма пополнения' : 'Стоимость номинала',
    value: <>{toPriceFormat(base, {
        trimIfInteger: true
      })} ₽</>
  }, {
    label: 'Комиссия сервиса',
    value: isPromocodeActivated ? <FeeWrapper>
          <CrossedText>{fee}</CrossedText> 0 ₽
        </FeeWrapper> : <>{toPriceFormat(fee, {
        trimIfInteger: true
      })} ₽</>
  }, {
    label: 'Итого',
    value: <>{toPriceFormat(total, {
        trimIfInteger: true
      })} ₽</>
  }];
};
const CrossedText = /*#__PURE__*/styled('span')({
  name: "CrossedText",
  class: "cmv2mvd",
  propsAsIs: false
});
const FeeWrapper = /*#__PURE__*/styled('p')({
  name: "FeeWrapper",
  class: "fkvxn0j",
  propsAsIs: false
});

require("./getAmountInfoRows.linaria.module.css!=!../../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./getAmountInfoRows.tsx");